import { Reveal } from "../Reveal";
import { Heart } from "lucide-react";

export const Community = () => {
  return (
    <section
      id="community"
      data-testid="community-section"
      className="relative min-h-[80vh] flex items-center overflow-hidden"
    >
      <img
        src="/mpm/work3.jpg"
        alt="Fraser River, Ladner BC"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-[#09090b]/70" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#09090b] via-[#09090b]/50 to-transparent" />

      <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8 py-28 w-full">
        <div className="max-w-2xl">
          <Reveal>
            <span className="inline-flex items-center gap-2 text-[#e85d04] text-xs font-bold tracking-[0.28em] uppercase">
              <Heart size={14} className="fill-[#e85d04]" /> Community
            </span>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-display font-bold text-white text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-5 leading-[1.03]">
              This river is home.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-7 text-lg text-white/75 font-light leading-relaxed">
              We're proud to work the mighty Fraser and the Southern BC Coast —
              the same waters our neighbours live, fish and play on. Supporting
              local means showing up for beach clean-ups, lending a hand to
              fellow boaters, and treating every job like it's for family.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <p className="mt-6 font-display font-semibold text-xl text-white">
              Local waters. Local crew. Local pride.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
